export default __webpack_public_path__ + "static/media/sclerotherapy.02181bd3.pdf";